module.exports = __webpack_public_path__ + "static/media/12x16no1.99580eed.jpg";